// cspell:ignore bekim rayan
import {
  isRedoEmailAddress,
  REDO_EMAIL_DOMAINS,
} from "@redotech/account-common/redo-domains";

export function matchesRedoUser(
  email: string | undefined,
  localParts: readonly string[],
): boolean {
  if (!email) {
    return false;
  }
  const normalized = email.toLowerCase().trim();
  const atIndex = normalized.lastIndexOf("@");
  if (atIndex === -1) {
    return false;
  }
  const local = normalized.slice(0, atIndex);
  const domain = normalized.slice(atIndex + 1);
  return localParts.includes(local) && REDO_EMAIL_DOMAINS.includes(domain);
}

/**
 * The users who I (@bcarper) trust with experimental features as a result of
 * demonstrated high attention to detail and knowledge of the entire product
 * and its feature's implications. Each local part is matched against both
 * `@getredo.com` and `@redo.com`.
 */
const trustedAdminCheckoutOptimizationLocalParts = [
  "bcarper",
  "coleman",
  "cameron.walker",
  "aradford",
  "grant",
  "abby.woodward",
  "dev",
  "bekim",
  "rayan",
  "isaac.smith",
  "brett.gunter",
  "braden",
  "colt",
];

export function isTrustedAdminCheckoutOptimizationUser(
  email: string | undefined,
): boolean {
  return matchesRedoUser(email, trustedAdminCheckoutOptimizationLocalParts);
}

const adminCheckoutOptimizationLocalParts = [
  ...trustedAdminCheckoutOptimizationLocalParts,
  "daisy",
  "cameron.buford",
];

export function isAdminCheckoutOptimizationUser(
  email: string | undefined,
): boolean {
  return matchesRedoUser(email, adminCheckoutOptimizationLocalParts);
}

export function isRedoUser(email: string | undefined): boolean {
  return isRedoEmailAddress(email);
}
